import { LemmonPOSEnvDef } from "@app/server/routes/helpers";
import { PrinterStatuses, User } from "../types";
import { Context } from "hono";

export * from "./payments/index";
export * from "./utils";
export * from "./dateGrouping";

export const getErrorWithTag = (message: string, user: User) => {
  return new Error(
    `${message} [${user.profile.name} | ${user.restaurant.name}]`,
  );
};

export const PRINTER_POLLING_INTERVAL = 25 * 1000;

export const isPrinterOnline = (
  printerStatuses: PrinterStatuses["timestamps"],
  printerId: number,
) => {
  const lastSeen = printerStatuses[printerId.toString()];
  return lastSeen &&
    Number.isFinite(lastSeen) &&
    lastSeen > Date.now() - PRINTER_POLLING_INTERVAL
    ? true
    : false;
};
